import _ from 'lodash';
import isoCountries from './isoCountries.json';

export default (code) => {
  const country = _.find(isoCountries, (c) => {
    return c.name.toLowerCase() === code.toLowerCase() || c.code.toLowerCase() === code.toLowerCase();
  });
  return country ? country.name : null;
};
